import { useLocation, useParams } from 'react-router-dom';

export const usePclDeviceId = () => {
  const { deviceID: deviceIdParam } = useParams<{ deviceID?: string }>();
  const location = useLocation<{ deviceID?: string }>();
  const deviceIdState = location.state?.deviceID;

  return {
    deviceIdParam,
    deviceIdState,
    deviceID: deviceIdParam || deviceIdState,
    hasDeviceIdParam: !!deviceIdParam,
  };
};
